// extracted by mini-css-extract-plugin
export default {"add":"control_add__nZOQ-","tooltip":"control_tooltip__fYpvn"};